export default "__VITE_ASSET__CjhWqPVZ__"